Wee.fn.make('subjectLinks', {
	init: function() {
		var scope = this;

		Wee.events.on({
			'ref:science': {
				click: function() {
					scope.scrollBody('#science');
				}
			},
			'ref:math': {
				click: function() {
					scope.scrollBody('#math');
				}
			},
			'ref:history': {
				click: function() {
					scope.scrollBody('#history');
				}
			},
			'ref:english': {
				click: function() {
					scope.scrollBody('#english');
				}
			}
		});
	},
    
	scrollBody: function(id) {
		Wee.animate.tween('body', {
			scrollTop: $(id).offset().top
		}, {
			duration: 800
		});
	}
});

Wee.subjectLinks.init();